import {SiteStyle} from '@types';

import {useUserPreferences} from './useUserPreferences';

export const useGameStyleEnabled = () => {
    const {preferences, isLoading} = useUserPreferences();

    return {
        isGameStyleEnabled: preferences?.siteStyle === SiteStyle.GAME,
        isLoading,
    };
};
